// 迁移内容2025.2.26
export default {
  'migrate.layout.text1':
    '请确保在2025.2.26（UTC+8）之前在新平台完成你的迁移。旧平台将在未来不久下架。新平台将提供更好的功能服务，并继承您在旧平台上的剩余余额。如何你有任何问题，请联系客服或发送邮件至 support@lightcdn.com。前往新平台→ ',
  'migrate.layout.text2':
    '你已经在新平台确认开始使用。旧平台将在2025.2.26（UTC+8）下架。如有必要，请尽快下载历史数据，并将CDN资源迁移到新平台。转到新平台→',
  'migrate.MoveContent.title1': '迁移超简单，复制激活即可！',
  'migrate.MoveContent.title2': '感谢你一如既往的支持! LightCDN将为你更好的服务！',
  'migrate.MoveContent.title1.step1': '复制你的专属代码：',
  'migrate.MoveContent.title1.step2.0': '前往',
  'migrate.MoveContent.title1.step2.1': '新平台',
  'migrate.MoveContent.title1.step2.2': '概览',
  'migrate.MoveContent.title1.step2.3': '，粘贴你的专属代码。',
  'migrate.MoveContent.title1.step3': '等待五分钟，余额迁移，资源自动为你创建完成。',
  'migrate.MoveContent.title1.step4': '激活资源即可使用！',
  'migrate.MoveContent.title2.text': '迁移的过程需要5-10分钟，请勿关闭窗口！',
  'migrate.MoveContent.title2.input': '请填入您的专属代码',
  'migrate.MoveContent.title2.start': '开始迁移',
  'migrate.MoveContent.title2.tip': '*此功能仅针对在旧平台上还有正常业务资源的用户',
  'migrate.MoveContent.title2.step1': '激活30天 500G 核心档位额度...',
  'migrate.MoveContent.title2.step2': '正在为你准备迁移数据...',
  'migrate.MoveContent.title2.step3.0': '余额迁移...',
  'migrate.MoveContent.title2.step3.1': '资源创建...',
  'migrate.MoveContent.title2.step4': '迁移完毕，前往激活资源',
  'migrate.MoveContent.title2.step4.total': '资源创建情况：总计',
  'migrate.MoveContent.title2.step4.tip0':
    '请注意：资源创建范围为在旧客户端上依旧在正常使用的资源。',
  'migrate.MoveContent.title2.step4.tip1': '创建失败的原因：',
  'migrate.MoveContent.title2.step4.tip2': '1.可能已在新平台创建',
  'migrate.MoveContent.title2.step4.tip3':
    '2.可能受到网络波动未创建成功，这些失败的资源需要确认后自行手动创建',
  'migrate.MoveContent.title2.step4.tip4': '如果你失败的资源过多，请发送邮件至support@lightcdn.com',
  'migrate.MoveContent.title2.step4.btn': '前往资源列表',
  'migrate.MoveContent.title2.text.btn': '点击此处查看创建失败的资源',
  'migrate.APIKey': '为了确保你的迁移过程不会出现问题，我们将在迁移期间暂时停止API的对外开放。',
  'migrate.monthPlanAndRecharge':
    '为了确保你的迁移过程不会出现问题，我们将在迁移期间暂时停止购买月度计划和充值入口。',

  'migrate.register.title.0': '当前为LightCDN旧客户端平台，支持旧客户将平台内容迁移至新平台，',
  'migrate.register.title.1': '暂时不开放注册。',
  'migrate.register.title.2': '欢迎新用户前往新客户端平台（',
  'migrate.register.title.3': '）使用。',
  'migrate.register.left.title': '旧用户的迁移指南',
  'migrate.register.left.1.0': '前往',
  'migrate.register.left.1.1': '旧平台 → 主页',
  'migrate.register.left.1.2': '，复制你的专属代码。',
  'migrate.register.left.2.0': '在当前页面的迁移窗口中粘贴复制的专属代码。',
  'migrate.register.left.2.1': '',
  'migrate.register.left.2.2': '',
  'migrate.register.left.3': '单资源仅需要等待几秒即可完成。自动为你迁移余额，创建资源。',
  'migrate.register.left.4': '激活资源，完成DNS解析即可使用！',
  'migrate.register.right.title.1': '时间节点通知',
  'migrate.register.right.1.0': '迁移开始',
  'migrate.register.right.1.1':
    '新平台开放，你可以选择在合适的时间开始迁移资源，我们会协助你一键创建已有的资源，并转移你的余额（500G的核心网络流量无论是否用完都将会被重置，我们希望试用的客户也一并迁移）。单资源迁移只有几秒，重新dns解析即可，最小程度减少你的业务影响。',
  'migrate.register.right.1.2':
    '旧客户端平台会关闭充值和资源创建。已有的资源可以正常操作，不影响加速直到你迁移到新平台。',
  'migrate.register.right.title.2': '迁移结束',
  'migrate.register.right.2.0':
    '旧平台下架，这将意味着你在旧平台的资源停止加速，若你至此还没迁移，业务将会中断。',
};
